export default __webpack_public_path__ + "static/media/noImage.5459c988.svg";